export const UNSET_SCROLLED_LOCATION = 'unset-scrolled-location';
const unsetScrolledLocation = () => ({ type: UNSET_SCROLLED_LOCATION });
export default unsetScrolledLocation;
